import React from 'react';
import i18next from '../../i18n.js';
import { tripDestinations } from '../../constants.js';

const PinIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 21c4.5-4.2 7-7.4 7-11a7 7 0 10-14 0c0 3.6 2.5 6.8 7 11z" />
        <circle cx="12" cy="10" r="2.5" />
    </svg>
);

const GlobeIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="8.5" />
        <path d="M3.5 12h17M12 3.5c2.5 2.5 2.5 14 0 17M12 3.5c-2.5 2.5-2.5 14 0 17" />
    </svg>
);

const TripDestinationInput = (props) => {
    const { name, value, disabled } = props;

    const selectHandle = (destination) => {
        if (disabled || !props.onChange) return;
        props.onChange({
            target: {
                name: name,
                value: destination
            }
        });
    }

    const renderButton = (destination, icon, label) => (
        <button
            type="button"
            className={"trip-destination-btn" + (value === destination ? " selected" : "")}
            onClick={() => selectHandle(destination)}
            disabled={disabled ? "disabled" : ""}>
            {icon}
            <span>{label}</span>
        </button>
    );

    return (<div className="trip-destination-form">
        <input name={name} value={value ?? ''} type="hidden" readOnly />
        {renderButton(tripDestinations.ukraine, <PinIcon />, i18next.t('form.fields.tripDestinationUkraine'))}
        {renderButton(tripDestinations.abroad, <GlobeIcon />, i18next.t('form.fields.tripDestinationAbroad'))}
    </div>);
}

export default TripDestinationInput;
